import { lazy } from "react";

export { MY_WORK_PATH } from "./path";
export const MyWork = lazy(() => import("./page"));
